<section class="content-section" id="content">
  <div class="section-container">
    <div class="section-header">
      <div class="header-badge">
        <span class="badge-icon">📚</span>
        <span class="badge-text">Learning Resources</span>
      </div>
      <h2 class="section-title">Rich Educational Content</h2>
      <p class="section-subtitle">
        Comprehensive learning materials across all subjects and grade levels
      </p>
    </div>
    <div class="content-grid">
      <div class="content-category" *ngFor="let category of contentCategories; let i = index">
        <div class="category-header">
          <div class="category-icon-wrapper">
            <span class="category-icon">{{ category.icon }}</span>
          </div>
          <h3 class="category-title">{{ category.title }}</h3>
          <p class="category-description">{{ category.description }}</p>
        </div>
        <div class="category-stats">
          <div class="content-stats">
            <div class="stat-number">{{ category.items }}</div>
            <div class="stat-label">Items</div>
          </div>
          <div class="content-stats">
            <div class="stat-number">{{ category.levels }}</div>
            <div class="stat-label">Levels</div>
          </div>
        </div>
        <div class="category-glow"></div>
      </div>
    </div>
  </div>
</section>